import React from "react";

import { InfoRowProps } from "./Profile.types.tsx";

const InfoRow: React.FC<InfoRowProps> = ({ icon, label, value }) => (
  <div className="d-flex align-items-start mb-3">
    <div className="me-3 mt-1">{icon}</div>

    <div className="flex-grow-1">
      <div className="fw-semibold" style={{ fontSize: "0.8rem", lineHeight: 1.2 }}>
        {label}
      </div>
      <div style={{ fontSize: "1rem" }}>{value || "-"}</div>
    </div>
  </div>
);

export default InfoRow;
